import { useCallback, useState } from 'react'
import axios from 'axios'
import { useAuth0 } from '@auth0/auth0-react'
import { Button, Typography } from '@mui/material'

import { PortalPageFrame } from '../common'
import { Paper } from '../common/primitives'

// use Access Token to make a test API call to a protected route
const makeRequest = async (getTokenCallback) => {
  const accessToken = getTokenCallback ? await getTokenCallback() : ''
  console.log(accessToken)
  return axios({
    method: 'POST',
    url: '/api/protected',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}

const AuthTest = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()

  // this implements a really basic state management for api calls.
  // probably not the best implementation - for more robust handling
  // of managing state from external apis, see other examples:
  // - Metadata.js (from Jesse), and also Downloader.js and Uploader.js (slightly simpler)
  // - the Redux-based implementation in luther-frontend
  // - useApi() hook example from Auth0: https://github.com/auth0/auth0-react/blob/master/EXAMPLES.md#4-create-a-useapi-hook-for-accessing-protected-apis-with-an-access-token
  // - RTK Query from Redux: https://redux.js.org/tutorials/essentials/part-7-rtk-query-basics
  const [responseError, setResponseError] = useState('')
  const [responseBody, setResponseBody] = useState('')
  const [waiting, setWaiting] = useState(false)

  const handleClick = useCallback(() => {
    setResponseError('')
    setResponseBody('')
    setWaiting(true)
    // normally we should also get and test 'error' and 'isLoading' from useAuth0()
    // before allowing the user to make a request. (see AuthButton.js) however I wanted this test page
    // to demonstrate the behaviour of the API when making an unauthenticated request.
    makeRequest(isAuthenticated ? getAccessTokenSilently : null)
      .then((res) => setResponseBody(JSON.stringify(res.data)))
      .catch((err) => {
        setResponseError(err.message)
      })
      .finally(() => setWaiting(false))
  }, [
    isAuthenticated,
    getAccessTokenSilently,
    setResponseError,
    setResponseBody,
    setWaiting,
  ])

  return (
    <PortalPageFrame
      title="Auth Test"
      Paper={(props) => <Paper {...props} maxWidth="1100px" />}
      actions={
        <Button color="secondary" variant="contained" onClick={handleClick}>
          Make Request
        </Button>
      }
    >
      <Typography paragraph>
        This page is for testing authorization. Click the button below to make a
        request to the API test endpoint.
      </Typography>
      {waiting ? <Typography paragraph>Waiting...</Typography> : null}
      {responseError ? (
        <Typography paragraph sx={{ color: 'red' }}>
          Error: {responseError}
        </Typography>
      ) : null}
      {responseBody ? (
        <Typography paragraph sx={{ color: 'green' }}>
          Response: {responseBody}
        </Typography>
      ) : null}
    </PortalPageFrame>
  )
}

export default AuthTest
